export default __webpack_public_path__ + "static/media/FORE.ba2dc39d.png";